import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const HTMLWrapperContainer = styled.div(
    ({ theme }) => css`
        margin-bottom: ${theme.spacing['24px']};

        iframe {
            width: 100%;
        }

        ${theme.mediaQueries.medium} {
            margin-bottom: ${theme.spacing['32px']};
        }
    `
);
